import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import { ManagerPettyCashAction, PettyCashAction } from "../../actions";
import * as PettyCashApi from "../../api/pettyCash/managerPettyCash";
import { toastr } from "react-redux-toastr";
import { SetMessage } from "../../assets/errorMessages";
import { GetFilter } from "../../hocs/pettCashReport/components/filter/filters";
import { GetFilter as GetTrashedSequenceFilter } from "../../hocs/pettCashReport/trashedSequence/filters";
import { MANAGER_CHANGE_STATE_MODES } from "../../constants/pettycash";
import { GetNumberFilter } from "../../hocs/pettCashReport/components/filter/numberFilters";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../../assets/fetchAllPageTogether";

export function* managerWatcherPettyCash() {
  yield takeLatest(types.MANAGER_GET_PETTY_CASH_REQUEST, get);
  yield takeLatest(types.MANAGER_GET_PETTY_CASH_ITEMS_REQUEST, getItems);
  yield takeLatest(types.MANAGER_GET_LIST_PETTY_CASH_REQUEST, list);
  yield takeLatest(
    types.MANAGER_GET_TRASHED_SEQUENCE_REQUEST,
    listTrashedSequence
  );
  yield takeLatest(
    types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_REQUEST,
    numberList
  );
  yield takeLatest(types.MANAGER_CHANGE_STATE_PETTY_CASH_REQUEST, changeState);
  yield takeLatest(types.UNDER_MANAGER_CONTROL_USERS_LIST_REQUEST, getUserList);
}

async function fetchGet(id, pageNum) {
  return PettyCashApi.get(id, pageNum);
}

function* get(action) {
  try {
    const response = yield call(fetchGet, action.id, action.pageNum);
    yield put(ManagerPettyCashAction.getRequestSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(
      ManagerPettyCashAction.getRequestFailure(
        message,
        error.response.data.data
      )
    );
  }
}

async function fetchItems(id, pageNum) {
  return PettyCashApi.getItems(id, pageNum);
}

function* getItems(action) {
  try {
    const response = yield call(fetchItems, action.id, action.pageNum);
    yield put(ManagerPettyCashAction.getItemsRequestSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashAction.getItemsRequestFailure(message));
  }
}

async function fetchList(pageNumber = null) {
  const filters = GetFilter();
  const page_number = pageNumber ? pageNumber : "";
  return PettyCashApi.getList(page_number, filters);
}

function* list(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(ManagerPettyCashAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashAction.getListFailure(message));
  }
}

async function fetchListTrashedSequence(pageNumber = null) {
  const filters = GetTrashedSequenceFilter();
  const page_number = pageNumber ? pageNumber : "";
  return PettyCashApi.getListTrashedSequence(page_number, filters);
}

function* listTrashedSequence(action) {
  try {
    const response = yield call(fetchListTrashedSequence, action.pageNumber);
    yield put(ManagerPettyCashAction.getTrashedSequenceSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashAction.getTrashedSequenceFailure(message));
  }
}

async function fetchNumberList(pageNumber = null) {
  const filters = GetNumberFilter();
  const page_number = pageNumber ? pageNumber : "";
  return PettyCashApi.getList(page_number, filters);
}

function* numberList(action) {
  try {
    const response = yield fetchAllPages(
      fetchNumberList,
      action.payload,
      defaultNormalizerWithSeparateMetaObj,
      null,
      true
    );
    yield put(
      ManagerPettyCashAction.getNumberListSuccess({ data: response.data })
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashAction.getNumberListFailure(message));
  }
}

async function fetchChangeState(id, data, func) {
  switch (func) {
    case MANAGER_CHANGE_STATE_MODES.RETURN:
      return PettyCashApi.sendBack(id, data);
    case MANAGER_CHANGE_STATE_MODES.REJECT:
      return PettyCashApi.reject(id, data);
    case MANAGER_CHANGE_STATE_MODES.REJECT_FINALIZE:
      return PettyCashApi.rejectFinalize(id, data);
    case MANAGER_CHANGE_STATE_MODES.FINALIZE:
      return PettyCashApi.finalize(id);
    case MANAGER_CHANGE_STATE_MODES.APPROVE:
      return PettyCashApi.approve(id, data);
  }
}

function* changeState(action) {
  try {
    const response = yield call(
      fetchChangeState,
      action.id,
      action.data,
      action.func
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const responseReq = yield call(fetchGet, action.id);
    yield put(ManagerPettyCashAction.changeStateSuccess(responseReq.data));
    yield put(PettyCashAction.reasonCloseModal());
  } catch (error) {
    SetMessage(error, true);
    yield put(
      ManagerPettyCashAction.changeStateFailure(error.response.data.data)
    );
  }
}

function fetchUserList(data) {
  return PettyCashApi.getUsersList(data);
}

function* getUserList(action) {
  try {
    const response = yield call(fetchUserList, action.data);
    let data = response.data.data;
    yield put(ManagerPettyCashAction.getUsersListSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ManagerPettyCashAction.getUsersListFailure(message));
  }
}
